module.exports = __webpack_public_path__ + "img/icon-no-permit.95b87b12.gif";